import { createI18n } from 'vue-i18n'
import enMessages from '../locales/en.json'
import idMessages from '../locales/id.json'
import { mark, proofreading } from './proofreading_markers'

function getLocale() {
  const localeMeta = document.querySelector('meta[name="locale"]')
  return (localeMeta && localeMeta.getAttribute('content')) || 'en'
}

const i18nInstance = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: 'en',
  messages: {
    en: enMessages,
    id: idMessages
  }
})

// Marked here rather than through a vue-i18n hook: every component reaches its
// copy through this one export, so it is the app's own seam.
export const t = (key, params) => {
  const translated = i18nInstance.global.t(key, params)

  return proofreading() && typeof translated === 'string' ? mark(key, translated) : translated
}

export default i18nInstance
